import { format, parseISO } from 'date-fns';
import { TNaerasPoolSource, TNaerasPoolState } from '@/data/types';

/**
 * Today on the Greek calendar, as YYYY-MM-DD. The pool's `as_of` can't stand in
 * for it: when the value is stale, `as_of` is the older day it came from.
 */
export function athensToday(): string {
  // en-CA formats as YYYY-MM-DD
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Athens' }).format(new Date());
}

/** How each pool source reads to an operator, and whether it is healthy. */
export const POOL_SOURCE_META: Record<
  TNaerasPoolSource,
  { label: string; healthy: boolean }
> = {
  manual: { label: 'Χειροκίνητη τιμή', healthy: true },
  reconciled: { label: 'Εκκαθαρισμένο', healthy: true },
  stale: { label: 'Εκκρεμεί εκκαθάριση', healthy: false },
  seed: { label: 'Αρχική τιμή', healthy: false },
};

/** "Εκκαθαρισμένο (12/10/2026 00:00)", "Εκκρεμεί εκκαθάριση 2 ημερών", … */
export function poolSourceLabel(pool: TNaerasPoolState): string {
  const day = format(parseISO(pool.as_of), 'd/M/yyyy');

  switch (pool.source) {
    case 'manual':
      return `Χειροκίνητη τιμή (${day} 00:00)`;
    case 'reconciled':
      return `Εκκαθαρισμένο (${day} 00:00)`;
    case 'stale':
      return `Εκκρεμεί εκκαθάριση ${pool.stale_days} ημερών`;
    default:
      return 'Αρχική τιμή — δεν έχει γίνει εκκαθάριση';
  }
}
